"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
require("./LoginCallback.scss");
var action_1 = require("../../components/languageSelector/redux/action");
var mapDispatchToProps = {
    dispatchChangeLanguage: action_1.changeLanguage,
};
var connector = react_redux_1.connect(undefined, mapDispatchToProps);
var LoginCallback = function (props) {
    var authService = props.authService, applicationLogo = props.applicationLogo, applicationName = props.applicationName, children = props.children, languageFromToken = props.languageFromToken, dispatchChangeLanguage = props.dispatchChangeLanguage;
    var location = react_router_dom_1.useLocation();
    react_1.useEffect(function () {
        var asyncCall = function () { return __awaiter(void 0, void 0, void 0, function () {
            var user, locale;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, authService.loginCallback(location.hash)];
                    case 1:
                        user = _a.sent();
                        if (languageFromToken && user) {
                            locale = user.profile.locale;
                            if (Array.isArray(locale)) {
                                if (locale.length > 0) {
                                    dispatchChangeLanguage(locale[0]);
                                }
                            }
                            else if (typeof locale === 'string') {
                                dispatchChangeLanguage(locale);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        asyncCall();
    }, [location]);
    return children ? (react_1.default.createElement(react_1.default.Fragment, null, children)) : (react_1.default.createElement("div", { className: "loginPage" },
        react_1.default.createElement("img", { src: applicationLogo, alt: "Application logo" }),
        react_1.default.createElement("h1", null, applicationName)));
};
exports.default = connector(LoginCallback);
//# sourceMappingURL=LoginCallback.js.map